var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7FB",
    d: "M85,9H24.7c-2.5,0-4.6,2.1-4.6,4.6v100.8c0,2.5,2.1,4.6,4.6,4.6h78.5c2.5,0,4.6-2.1,4.6-4.6V31.9L85,9v18.3c0,2.5,2.1,4.6,4.6,4.6h18.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEDFE6",
    d: "M85.1 94.5H41c-1.7 0-3-1.3-3-3s1.3-3 3-3h44.1c1.7 0 3 1.3 3 3S86.8 94.5 85.1 94.5zM85.1 76.2H41c-1.7 0-3-1.3-3-3s1.3-3 3-3h44.1c1.7 0 3 1.3 3 3S86.8 76.2 85.1 76.2zM85.1 57.8H41c-1.7 0-3-1.3-3-3s1.3-3 3-3h44.1c1.7 0 3 1.3 3 3S86.8 57.8 85.1 57.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464C55",
    d: "M110,29.8L87.1,6.9C86.5,6.4,85.6,6,84.7,6c0,0,0,0,0,0H24.7c-4.2,0-7.6,3.4-7.6,7.6v100.8c0,4.2,3.4,7.6,7.6,7.6h78.6c4.2,0,7.6-3.4,7.6-7.6V31.9C110.9,31.1,110.5,30.3,110,29.8z M88,16.2l12.7,12.7H89.6c-0.9,0-1.6-0.7-1.6-1.6V16.2z M104.8,114.4c0,0.9-0.7,1.6-1.6,1.6H24.7c-0.9,0-1.6-0.7-1.6-1.6V13.6c0-0.9,0.7-1.6,1.6-1.6h57.2v15.3c0,4.2,3.4,7.6,7.6,7.6h15.3V114.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.847194e8620b3bee6d7f2159feadccab.svg";
export { ForwardRef as ReactComponent };